export default __webpack_public_path__ + "static/media/importio.8dc2c42b.svg";